"use client";

import { Suspense } from "react";

import { LocationToContent } from "@/app/page-schema/location-to-page.schema";
import QuestionsStateProvider from "@/providers/questions-state-provider";

import LocationToSection from "./component/location-to-section";
import LocationToProvider from "./provider/location-to-provider";

type TravellingToPageProps = {
  overlayArea: LocationToContent;
};

function TravellingToPage({ overlayArea }: Readonly<TravellingToPageProps>) {
  return (
    <Suspense fallback={<div />}>
      <QuestionsStateProvider>
        <LocationToProvider>
          <LocationToSection overlayArea={overlayArea} />
        </LocationToProvider>
      </QuestionsStateProvider>
    </Suspense>
  );
}

export default TravellingToPage;
